import { createFileRoute } from '@tanstack/react-router';
import { TransfersListPage } from '@/components/app/TransfersListPage';

export const Route = createFileRoute('/app/transfers/')({
  component: TransfersListPage,
});
